'use strict';

import { API } from '@spinnaker/core';
import { IPromise } from 'angular';

export class TerraformService {

  public static getVersions(): IPromise<string[]> {
    return API.one('/armory/terraformer/api/v1/system/versions')
      .get();
  }

  public static getProfiles(): IPromise<string[]> {
    return API.one('/armory/terraformer/api/v1/profile')
      .get();
  }

  public static getLogs(id: string): IPromise<any> {
    return API.one(`/armory/terraformer/api/v1/job/${id}/logs`)
      .get();
  }

}
